





























import Vue from "vue"
import FilterListItemFrame from "./FilterListItemFrame.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    FilterListItemFrame,
    MaterialIcon,
  },
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    isVisibleFilter: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
  },
  methods: {
    handleClickToggleButton() {
      if (this.disabled) {
        this.$emit("click-toggle-button-when-disabled")
      } else {
        this.$emit("click-toggle-button")
      }
    },
  },
})
